import React from "react";

const COPY = {
  it: {
    processing: "Stiamo confermando il pagamento…",
    paidTitle: "Pagamento completato!",
    premium: "Premium attivato! Tutti i contenuti sono sbloccati. 👑",
    pro: "CelestApp Pro attivato per 30 giorni! ✨",
    tournament: "Iscrizione al torneo confermata! 🏆",
    cancelled: "Pagamento annullato",
    cancelledMsg: "Nessun addebito effettuato. Puoi riprovare quando vuoi.",
    error: "Pagamento non confermato",
    errorMsg: "Non siamo riusciti a verificare il pagamento. Se hai pagato, l'attivazione arriverà a breve: ricarica la pagina tra qualche minuto.",
    ok: "Vai alla dashboard",
    unpaid: "Il pagamento non risulta ancora completato.",
  },
  en: {
    processing: "Confirming your payment…",
    paidTitle: "Payment completed!",
    premium: "Premium activated! All content is unlocked. 👑",
    pro: "CelestApp Pro activated for 30 days! ✨",
    tournament: "Tournament registration confirmed! 🏆",
    cancelled: "Payment cancelled",
    cancelledMsg: "Nothing was charged. You can try again anytime.",
    error: "Payment not confirmed",
    errorMsg: "We couldn't verify the payment. If you paid, activation will arrive shortly: reload the page in a few minutes.",
    ok: "Go to dashboard",
    unpaid: "The payment is not completed yet.",
  },
};

export function PaymentResultModal({ result, lang = "it", onClose }) {
  if (!result) return null;
  const c = COPY[lang] || COPY.it;
  const paid = result.status === "paid";
  const icon = result.status === "processing" ? "⏳" : paid ? (result.type === "tournament" ? "🏆" : "👑") : result.status === "cancelled" ? "🙅" : "⚠️";
  const title = result.status === "processing" ? c.processing : paid ? c.paidTitle : result.status === "cancelled" ? c.cancelled : result.status === "error" ? c.error : c.unpaid;
  const msg = paid ? (c[result.type] || c.premium) : result.status === "cancelled" ? c.cancelledMsg : result.status === "error" ? c.errorMsg : "";
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-[60]" data-testid="payment-result-modal">
      <div className="bg-white rounded-3xl p-8 max-w-md w-full text-center shadow-2xl">
        <div className={`text-6xl mb-4 ${result.status === "processing" ? "animate-pulse" : paid ? "animate-bounce" : ""}`}>{icon}</div>
        <h3 className="text-2xl font-bold text-gray-800 mb-2" data-testid="payment-result-title">{title}</h3>
        {msg && <p className="text-gray-500 mb-4" data-testid="payment-result-msg">{msg}</p>}
        {result.status !== "processing" && (
          <button
            onClick={onClose}
            className="mt-2 px-8 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-500 text-white font-bold hover:opacity-90"
            data-testid="payment-result-ok-btn"
          >
            {c.ok}
          </button>
        )}
      </div>
    </div>
  );
}
